import { Component } from "react";

import { withTranslation } from "react-i18next";
import type { WithTranslation } from "react-i18next";
import { connect } from "react-redux";

import { TrophyIcon } from "@lucide/icons";

import { OpenAPI } from "simplydo/interfaces";
import { withTheme } from "simplydo/react/theme";
import type { UseThemeType as DefaultTheme } from "simplydo/react/theme";
import { GridColumn } from "simplydo/react/ui/grid";
import { Icon } from "simplydo/react/ui/icon";

import type { FeedAchievementItem, FeedCardSharedProps } from "../types";
import FeedCard from "./FeedCard";

type CardLeftProps = { achievement: FeedAchievementItem; theme: DefaultTheme };

const CardLeft = withTheme(({ achievement, theme }: CardLeftProps) => (
  <GridColumn stretched verticalAlign="middle">
    <div className="cover-and-text">
      <Icon
        style={{ color: theme.primaryColour, fontSize: "3em" }}
        icon={TrophyIcon}
        size="large"
      />
      <div style={{ marginLeft: 5, fontSize: "1.2em" }}>
        <span style={{ fontWeight: 600 }}>{achievement.name}</span>
        <br />
        <span>{achievement.description}</span>
      </div>
    </div>
  </GridColumn>
));

type AchievementCardOwnProps = FeedCardSharedProps & {
  achievement: FeedAchievementItem;
  profileUser?: OpenAPI.Schemas["PreparedUser"];
};

type AchievementCardProps = AchievementCardOwnProps &
  WithTranslation & { user?: OpenAPI.Schemas["PreparedUser"] };

class AchievementCard extends Component<AchievementCardProps> {
  render() {
    const { achievement, user, profileUser, feedType } = this.props;
    const you = profileUser || user;
    return (
      <FeedCard
        user={you}
        feedType={feedType}
        action="activityFeed.achievements.action"
        date={achievement.achievedAt}
        toLink="/achievements"
        type="ACHIEVEMENTS"
        cardContent={<CardLeft achievement={achievement} />}
      />
    );
  }
}

const mapStateToProps = (state: {
  user?: OpenAPI.Schemas["PreparedUser"];
}) => ({ user: state.user });

const AchievementCardContainer = connect(mapStateToProps)(AchievementCard);

export default withTranslation()(AchievementCardContainer);
